import type { ReactNode } from 'react'
import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import type { Association } from '@/pages/StaffSignInPage'

export function GiveShell({
  association,
  screen,
  outcome,
  error,
  campaignId = '',
  children,
}: {
  association: Association
  screen: string
  outcome: string | null
  error: boolean
  campaignId?: string
  children: ReactNode
}) {
  return (
    <main className="min-h-screen bg-background px-6 py-6 text-foreground">
      <div className={`mx-auto w-full ${campaignId ? 'max-w-4xl' : 'max-w-xl'}`}>
        <header className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-body-sm text-primary-foreground">
              {association.name.slice(0, 1)}
            </span>
            <span className="text-body-sm font-medium">{association.name}</span>
          </div>
          <Button
            type="button"
            variant="ghost"
            className="h-8 px-2 text-caption text-muted-foreground"
          >
            Cancel
          </Button>
        </header>
        <div className="mb-5 flex items-center gap-2 text-caption text-muted-foreground">
          <span className={screen === 'amount' ? 'font-medium text-foreground' : ''}>
            1. Amount
          </span>
          <span aria-hidden="true">/</span>
          <span className={screen === 'details' ? 'font-medium text-foreground' : ''}>
            2. Details
          </span>
        </div>
        {outcome && (
          <Alert variant="warning" className="mb-4">
            Your payment did not complete. Your gift was not recorded. You can try again.
          </Alert>
        )}
        {error && <Alert className="mb-4">Give details are currently unavailable.</Alert>}
        {children}
      </div>
    </main>
  )
}
